module.exports = __webpack_public_path__ + "media/Icons/ConfirmedIconInverted-fb4b229f.png";